<template>
  <div class="tabber">
    <div class="tabberTop" :style="topWidth">
      <div class="tabberTitle">{{ tabTitle }}</div>
      <ul class="tabberWrap">
        <li
          class="tabberList"
          @click="changeTabber(item.id)"
          v-for="item in tabberData"
          :key="item.id"
          :class="activeIndex == item.id ? 'tabberListActive' : ''"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>

    <div class="tabberContent" :style="contentWidth">
      <slot name="tabberContent"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ["tabberData", "activeIndex", "tabTitle"],
  data() {
    return {
      topWidth: "width:1200px;margin:0 auto",
      contentWidth: "width:1200px;margin:0 auto",
    };
  },
  methods: {
    changeTabber(index) {
      this.$emit("changeTabber", index);
    },
  },
  mounted() {
    if (this.$route.name == "newsCenter") {
      this.topWidth = "width:1000px;margin:0 auto";
      this.contentWidth = "width:1000px;margin:0 auto";
    } else if (this.$route.name == "recruit"  ) {
      this.topWidth = "width:1300px;margin:0 auto";
      this.contentWidth = "width:1300px;margin:0 auto";
    }else if(this.$route.name == "aboutUs"){
       this.topWidth = "width:1000px;margin:0 auto";
      this.contentWidth = "width:1000px;margin:0 auto";
    }
  },
};
</script>
<style scoped>
.tabber {
  margin: 0 auto;
  width: 1300px;
}
.tabberTitle {
  color: #655246;
  font-size: 24px;
  font-weight: bold;
}
.tabberTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 98px;
  line-height: 98px;
  border-bottom: 2px solid #eaeaea;
}
.tabberWrap {
  display: flex;
}
.tabberList {
  margin-left: 30px;
  font-size: 16px;
  color: #999;
  cursor: pointer;
}
.tabberListActive {
  color: #428fef;
  border-bottom: 2px solid #428fef;
}
.tabberContent {
  padding: 55px 0 65px;
}
.tabberContent video{
  display: block;
  margin:0 auto;
}
</style>